.spellList {
  list-style: none;
  padding: 0;
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));

  > * {
    animation: fadeIn 300ms ease-out;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
}
